import {getBindings, env} from "./config";

let bindings = getBindings()
const DEMO_POSTAL_CODE = '70125';
export const DEMO_POSTAL_WARNING_MSG = 'Demo Environment, Please use ZIP Code 70125.';

export function isPostalLockedWithWrongPostal(postalCode) {
    return (env === "demo" || env === "demoConsumer") && bindings?.demoParams?.lockPostalCode && postalCode !== DEMO_POSTAL_CODE
}